<template>
  <svg class="svg-icon" aria-hidden="true">
    <use :xlink:href="svgId"></use>
  </svg>
</template>

<script setup>
import { ref } from 'vue'
// 可使用类名传递修改大小
const props = defineProps({
  svgId: {
    type: String,
    required: true,
    default: '',
  },
})
</script>

<style lang="scss" scoped></style>
